import { render, staticRenderFns } from "./selectChoiceUser.vue?vue&type=template&id=b9ed6de6&"
import script from "./selectChoiceUser.vue?vue&type=script&lang=js&"
export * from "./selectChoiceUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports